import * as React from 'react'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

import * as api from '@owl-nest/api-client/next'
import * as hooks from '@owl-nest/hooks'
import { t, tc } from '@owl-nest/localize'
import * as shadow from '@owl-nest/shadow'
import * as layout from '@ulule/layout'

import * as UFE from '../../../../UFE'

import { TRACKING_SOURCE } from '../utils/trackerEnums'

type LaunchShareModalProps = {
  project: api.Project
}

export function LaunchShareModal({ project }: LaunchShareModalProps): React.ReactElement {
  const { href, search } = window.location
  const urlParams = new URLSearchParams(search)

  const setIsProjectDetailLaunchShareModalOpen = hooks.useSetModal('ProjectDetailLaunchShare')

  const modalCalloutMessage = getCalloutMessage()

  return (
    <layout.modals.ShareProject
      closable={false}
      enableConfetti
      modalId="ProjectDetailLaunchShare"
      modalButtons={[
        {
          type: 'button',
          props: {
            kind: 'primary',
            type: 'button',
            onClick: () => {
              urlParams.delete('launch')
              const newUrl = href.replace(search.substring(1), urlParams.toString())
              window.history.replaceState({}, '', newUrl)
              setIsProjectDetailLaunchShareModalOpen(false)
            },
            children: t('See my project'),
          },
        },
      ]}
      modalHero={
        <>
          <ModalTitle>{t('Congratulations, your project is live!')}</ModalTitle>
          <ModalDescription>
            {t(
              'Your campaign starts now: share your project with your first circle to to raise the gauge and launch this adventure.',
            )}
          </ModalDescription>
          {modalCalloutMessage && <Callout type="success">{modalCalloutMessage}</Callout>}
        </>
      }
      modalPastille={<plume.illustrations.twoToned.Rocket size={plume.utils.isMobile() ? 52 : 120} />}
      publicUser={UFE.CURRENT_USER}
      project={project}
      sharingContext="success-modal"
      trackingConfig={{ category: shadow.CATEGORY.PROJECT_PAGE, source: TRACKING_SOURCE.HERO }}
    />
  )

  function getCalloutMessage(): string | undefined {
    if (project.onboarding_steps?.import_community?.import_type === api.ImportType.PREVIOUS_BACKER) {
      return project.fans_count > 1
        ? t(
            'The %(fansCount)d pre-registered fans as well as all the backers of your previous project(s) have been notified by email.',
            { fansCount: project.fans_count },
          )
        : t('All previous backers for your past project(s) has been notified by email.')
    }

    if (project.onboarding_steps?.import_community?.import_type === api.ImportType.NONE) {
      if (project.fans_count > 1) {
        return t('The %(fansCount)d pre-registered fans have been notified by email.', {
          fansCount: project.fans_count,
        })
      }
    }

    return undefined
  }
}

const ModalDescription = styled(plume.styles.copy.M.light)`
  text-align: center;
`

const ModalTitle = styled(plume.styles.heading.L)`
  margin-bottom: 16px;
  text-align: center;
`

const Callout = styled(plume.Callout)`
  margin-bottom: 32px;
`
